// extracted by mini-css-extract-plugin
export default {"content":"MainLayout_content__tzfNN"};